var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessagesuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 147,
    viewBox: "0 0 166 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.6487 147C120.3 147 153.254 114.093 153.254 73.5C153.254 32.9071 120.3 0 79.6487 0C38.9974 0 6.04297 32.9071 6.04297 73.5C6.04297 114.093 38.9974 147 79.6487 147Z",
    fill: "url(#paint0_linear_2914_5611)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.284 55.0918H48.0234L79.6493 77.8126L111.284 55.0918Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6479 83.0574L47.1719 59.7314V95.6661H112.132V59.7314L79.6479 83.0574Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2914_5611",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 148,
    height: 147
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6487 147C120.3 147 153.254 114.093 153.254 73.5C153.254 32.9071 120.3 0 79.6487 0C38.9974 0 6.04297 32.9071 6.04297 73.5C6.04297 114.093 38.9974 147 79.6487 147Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2914_5611)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.44332 69.6035C0.404215 69.6035 -4.94672 68.5697 -10.6718 66.2157C-16.7337 63.7371 -21.1492 60.6234 -24.1801 56.7C-30.716 48.2554 -30.4166 37.0832 -29.4936 25.4127L-27.6227 25.5622C-28.5332 36.859 -28.8326 47.6451 -22.6958 55.5666C-19.8645 59.2159 -15.6985 62.1304 -9.9484 64.4969C-4.3979 66.7762 0.76593 67.7851 5.61794 67.7851C25.238 67.7851 39.6943 51.2696 53.7639 35.2025L54.138 34.7665C69.3551 17.3916 85.2458 8.16239 105.652 4.86178C110.491 4.07711 126.818 2.1092 133.554 9.78155C136.61 13.269 137.208 18.1514 135.35 24.3167C134.277 27.8788 132.344 31.0923 130.485 34.1936C129.55 35.7505 128.577 37.3697 127.741 39.0013C125.234 43.8712 124.187 48.4298 124.648 52.5525C125.446 59.7515 132.07 65.2567 139.753 65.1819C144.979 65.0948 149.981 62.8902 154.172 60.7355C174.677 50.2358 191.528 51.9048 212.059 57.9953C212.72 58.1946 214.928 58.9544 215.726 60.5611C216.05 61.2212 216.088 61.9312 215.826 62.6286L214.08 61.9685C214.155 61.7692 214.142 61.5949 214.055 61.3956C213.755 60.7977 212.72 60.1376 211.535 59.7889C191.454 53.8229 174.989 52.1788 155.032 62.4045C150.642 64.6464 145.403 66.963 139.79 67.0502C131.184 67.2121 123.7 60.9098 122.802 52.7642C122.303 48.2803 123.413 43.3606 126.095 38.1543C126.956 36.4729 127.941 34.8288 128.901 33.247C130.785 30.1083 132.568 27.1315 133.579 23.7936C135.238 18.2884 134.764 13.9914 132.169 11.0271C126.07 4.07711 110.579 5.97028 105.976 6.71759C86.0316 9.94347 70.4902 18.9859 55.5724 36.012L55.1982 36.448C41.3781 52.1663 26.0987 69.6035 5.44332 69.6035Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2914_5611",
    x1: 23.5559,
    y1: 26.277,
    x2: 138.998,
    y2: 123.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB19E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA8B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesuccess);
export default __webpack_public_path__ + "static/media/messagesuccess.e3f91c2210bf57211ab8f52167832ef3.svg";
export { ForwardRef as ReactComponent };